import axios from '../../../../../configs/axios';

export const getSimilarApps = data => axios.post('/search/similar_apps', data);

export const getReportCharts = data => axios.post('/pdf_reports/competitors_charts', data);

export const createPdfReport = data => axios.post('/pdf_reports', data);
